import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCaseheaderinfo } from "../../services/CaseInformationApi";

export const fetchCaseStages = createAsyncThunk(
  "case/fetchCaseStages",
  async (caseInfoID: number) => {
    const response = await fetchCaseheaderinfo(caseInfoID);
    return response?.caseStageName;
  }
);

interface CurrentStage {
  currentStage: string;
}

const initialState: CurrentStage = {
  currentStage: "",
};

const caseStagesSlice  = createSlice({
  name: 'caseStage',
  initialState,
  reducers: {
    setCurrentStage: (state, action) => {
      state.currentStage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCaseStages.fulfilled, (state, action) => {
      state.currentStage = action.payload;
    });
  },
});

export const { setCurrentStage  } = caseStagesSlice.actions;
export default caseStagesSlice.reducer;
